import Action, { ActionProps } from 'modules/Layout/component/Action/index';
import { ColorVariants } from 'modules/Shared/type';
import React from 'react';

const ActionRedo: React.FC<ActionProps> = ({
  label = <i className="fas font-20 fa-redo" />,
  color = ColorVariants.Warning,
  ...props
}: ActionProps): JSX.Element => {
  return (
    <Action
      {...props} // eslint-disable-line react/jsx-props-no-spreading
      label={label}
      color={color}
    />
  );
};

export default ActionRedo;
